import { render } from "./disinfectadd.vue?vue&type=template&id=42798ff1&scoped=true&ts=true"
import script from "./disinfectadd.vue?vue&type=script&lang=ts"
export * from "./disinfectadd.vue?vue&type=script&lang=ts"

import "./disinfectadd.vue?vue&type=style&index=0&id=42798ff1&scoped=true&lang=scss"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42798ff1"]])

export default __exports__